import React from 'react';
import DonateButton from './DonateButton';
import RecentDonations from './RecentDonations';

const DonationCTA: React.FC = () => {
  return (
    <section className="py-20">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center gap-12">
          <div className="md:w-1/2 text-center md:text-left">
            <h2 className="text-3xl font-bold mb-6 text-gray-800">Help Us Create More Pawsitive Futures</h2>
            <p className="text-xl mb-10 text-gray-700">
              Your donation directly funds essential veterinary care for pets in need and supports our mission to reduce pet overpopulation.
            </p>
            <DonateButton
              label="Donate Today"
              className="btn-primary px-12 py-4 rounded-full font-medium text-lg"
            />
          </div>
          <div className="md:w-1/2 flex justify-center">
            <RecentDonations />
          </div>
        </div>
      </div>
    </section>
  );
};

export default DonationCTA;
